import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type ActivitiesMultiSelectInput_query$key } from '@/__generated__/ActivitiesMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type ActivitiesMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: ActivitiesMultiSelectInput_query$key | null | undefined
}

export const ActivitiesMultiSelectInput = forwardRef<MultiSelectInputRef, ActivitiesMultiSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment ActivitiesMultiSelectInput_query on Query {
          activities(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <MultiSelectInput
        options={useMemo<SelectOption[]>(
          () =>
            map(queryData?.activities?.nodes, (activity) => ({
              label: activity!.name,
              value: activity!.rowId
            })),
          [queryData?.activities?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

ActivitiesMultiSelectInput.displayName = 'ActivitiesMultiSelectInput'
